import { TableStateManager } from '@common/components/table/types';
import { useState } from 'react';

export function useReactStateTableStateManager(): TableStateManager {
  return {
    usePaginationState(initialState) {
      return useState(initialState);
    },
    useSortingState(initialState) {
      return useState(initialState);
    },
    useColumnFiltersState(initialState) {
      return useState(initialState);
    },
  };
}
